<template>
  <div class="my-3 text-left">
    <v-snackbar top v-model="snackbar">
       <v-icon color="success" class="mr-2">check_circle_outline</v-icon>  Successfully copied to clipboard!
        <!-- <v-btn color="primary" flat @click="snackbar = false">X</v-btn> -->
      </v-snackbar>
    <div v-if="!loading">
      <v-toolbar dense flat color="white">
        <v-avatar size="60px" class="mr-2">
          <v-img contain :src="networkOperator.logo"></v-img>
        </v-avatar>
        <h3 class="title grey--text">Network Operator: {{ networkOperator.name }}
          <!-- <p>  <h6>Order Page URL: <v-btn @click="copyReference()" small icon><v-icon small>content_copy</v-icon></v-btn></h6> {{ networkOperator.applicationURL }}{{ '?isp=' }}{{ $store.state.currentOrg.org.reference }}</p> -->
        
        </h3>
        <!-- <br> -->
        <v-spacer></v-spacer>
        <v-btn small round color="primary" @click="copyReference()">
         <v-icon left small>content_copy</v-icon> Copy Order Page URL
        </v-btn>
      </v-toolbar>
      <!-- <v-layout wrap justify-start align-center class="my-0 py-0">

      <div class="text-xs-left ml-3" style="width: 80vw" v-if="networkOperator.applicationURL">
      </div>
      </v-layout> -->

      <v-toolbar dense flat color="white">
        <v-tabs div="tabs">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab href="#" v-model="tabs" v-for="tab in tabs" :key="tab.name" @click="setActiveTabName(tab.name)">{{
            tab.displayName
          }}</v-tab>
        </v-tabs>
      </v-toolbar>
      <div :key="key" v-if="displayContents('coverageMap')">
        <coveragemap :coordinates="geoData" />
      </div>

      <div v-if="displayContents('networkList')">
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field label="Search" v-model="networkSearch" clearable></v-text-field>
        </v-toolbar>
        <v-data-table
          :items="networks"
          :headers="networkHeaders"
          :search="networkSearch"
          :rows-per-page-items="[20, 50, 100]"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.item.organisation.name }}</td>
            <td class="text-xs-center">{{ props.item.name }}</td>

            <td class="text-xs-center" v-if="props.item.region">{{ props.item.region.name }}</td>
            <td v-else></td>
            <td v-if="props.item.networkStatus === 'Live'" class="text-xs-center">
              <v-chip small class="white--text" color="light-green">Live</v-chip>
            </td>
            <td v-if="props.item.networkStatus === 'In Progress'" class="text-xs-center">
              <v-chip small class="white--text" color="blue">In Progress</v-chip>
            </td>
            <td v-if="props.item.networkStatus === 'Planned'" class="text-xs-center">
              <v-chip small class="white--text" color="orange">Planned</v-chip>
            </td>
            <td class="text-xs-center">{{ props.item.numberOfUnits }}</td>
          </template>
        </v-data-table>
      </div>
      <div v-if="displayContents('packages')">
        <div v-if="globalFNOPackages.length > 0">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <h3 class="grey--text title">Globally Available FNO Packages</h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table :items="globalFNOPackages" :headers="globalFnoPackageHeaders" style="cursor: pointer">
            <template v-slot:items="props">
              <td class="text-xs-center" @click="addGlobalISPPackage(props.item)">
                <v-chip>{{ props.item.type }}</v-chip>
              </td>
              <td class="text-xs-center" @click="addGlobalISPPackage(props.item)">{{ props.item.packageCode }}</td>
              <td class="text-xs-center" @click="addGlobalISPPackage(props.item)">
                {{ props.item.packagesFnoCat.name }}
              </td>
              <td class="text-xs-center" @click="addGlobalISPPackage(props.item)">
                {{ props.item.packageBasePrice | currency }}
              </td>
              <td class="text-xs-center" @click="addGlobalISPPackage(props.item)">
                <v-layout justify-center align-center wrap>
                  <v-icon color="light-green">arrow_drop_down</v-icon> {{ props.item.speedProfile.downloadMbps }}
                  <v-icon color="red">arrow_drop_up</v-icon> {{ props.item.speedProfile.uploadMbps }}
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </div>
        <div v-if="globalIspPackages.length > 0">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <h3 class="grey--text title">My Globally Available Packages</h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-flex xs6>
              <v-text-field label="Search" v-model="globalIspPackagesSearch" clearable></v-text-field>
            </v-flex>
          </v-toolbar>

          <v-data-table
            :items="globalIspPackages"
            :search="globalIspPackagesSearch"
            :headers="globalIspPackageHeaders"
            style="cursor: pointer"
          >
            <template v-slot:items="props">
              <td>
                <v-layout justify-center align-center>
                  <v-icon @click="editGlobalISPPackage(props.item)">edit</v-icon>
                  <v-icon @click="deleteGlobalISPPackage(props.item)">delete</v-icon>
                </v-layout>
              </td>
              <td class="text-xs-center" @click="globalPackageSummaryredirect(props.item.id)">
                <v-chip>{{ props.item.packagesFno.type }}</v-chip>
              </td>
              <td class="text-xs-center" @click="globalPackageSummaryredirect(props.item.id)">{{ props.item.name }}</td>
              <td class="text-xs-center" @click="globalPackageSummaryredirect(props.item.id)">
                {{ props.item.onceOffPriceVatInc | currency }}
              </td>
              <td class="text-xs-center" @click="globalPackageSummaryredirect(props.item.id)">
                {{ props.item.recurringPriceVatInc | currency }}
              </td>
              <td class="text-xs-center" @click="globalPackageSummaryredirect(props.item.id)">
                <v-layout justify-center align-center wrap>
                  <v-icon color="light-green">arrow_drop_down</v-icon>
                  {{ props.item.packagesFno.speedProfile.downloadMbps }} <v-icon color="red">arrow_drop_up</v-icon>
                  {{ props.item.packagesFno.speedProfile.uploadMbps }}
                </v-layout>
              </td>
              <td class="text-xs-center">
                <v-chip
                  v-if="props.item.isActive"
                  color="light-green"
                  class="white--text"
                  @click="updatePackageStatus(props.item)"
                  >Visible</v-chip
                >
                <v-chip v-else color="red" class="white--text" @click="updatePackageStatus(props.item)"
                  >Not Visible</v-chip
                >
              </td>
            </template>
          </v-data-table>
        </div>
        <div v-if="activeNetworks.length > 0">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <h3 class="grey--text title">Network Specific Packages</h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table :items="activeNetworks" :headers="networkPackageHeaders" style="cursor: pointer">
            <template v-slot:items="props">
              <td class="text-xs-center" @click="packageSummaryredirect(props.item.id)">{{ props.item.name }}</td>
              <td
                @click="packageSummaryredirect(props.item.id)"
                v-if="props.item.networkStatus === 'Live'"
                class="text-xs-center"
              >
                <v-chip small class="white--text" color="light-green">Live</v-chip>
              </td>
              <td
                @click="packageSummaryredirect(props.item.id)"
                v-if="props.item.networkStatus === 'In Progress'"
                class="text-xs-center"
              >
                <v-chip small class="white--text" color="blue">In Progress</v-chip>
              </td>
              <td
                @click="packageSummaryredirect(props.item.id)"
                v-if="props.item.networkStatus === 'Planned'"
                class="text-xs-center"
              >
                <v-chip small class="white--text" color="orange">Planned</v-chip>
              </td>
              <td class="text-xs-center" @click="packageSummaryredirect(props.item.id)">
                {{ props.item.availablePackages.length }}
              </td>
              <td class="text-xs-center" @click="packageSummaryredirect(props.item.id)">
                {{ props.item.unusedPackages.length }}
              </td>
              <td class="text-xs-center" @click="packageSummaryredirect(props.item.id)">
                {{ props.item.currentPackages.length }}
              </td>
            </template>
          </v-data-table>
        </div>

        <v-card flat color="white" v-if="newNetworks.length > 0">
          <h2 class="grey--text title">New Networks</h2>
          <v-container v-if="newNetworks.length > 0" :key="key" fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md4 lg4 v-for="network in newNetworks" :key="network.id">
                <v-card hover mt-2 :tile="tile">
                  <v-toolbar flat color="grey">
                    <v-toolbar-title class="white--text text-xs-center">{{ network.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn small @click="addPackageTemplates(network)" round color="primary"
                      ><v-icon small>share</v-icon> Link to Package Templates</v-btn
                    >
                    <!-- <v-btn  round color="primary" @click="addPackageTemplates(network)" ><v-icon>add_circle_outline</v-icon>  Packages</v-btn> -->
                  </v-toolbar>
                  <v-card-text>
                    <v-container @click="packageSummaryredirect(network.id)" grid-list-xs>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12 text-xs-left>
                          <v-layout justify-left>
                            <v-flex xs8>
                              <h2 class="subheading grey--text font-weight-bold">Status:</h2>
                            </v-flex>
                            <v-flex xs4>
                              <h3 class="grey--text font-weight-light">
                                <v-chip
                                  small
                                  v-if="network.networkStatus === 'Live'"
                                  color="light-green"
                                  class="white--text"
                                  >{{ network.networkStatus }}</v-chip
                                >
                                <v-chip
                                  small
                                  v-else-if="network.networkStatus === 'Planned'"
                                  color="light-blue"
                                  class="white--text"
                                  >{{ network.networkStatus }}</v-chip
                                >
                                <v-chip
                                  small
                                  v-else-if="network.networkStatus === 'In Progress'"
                                  color="orange"
                                  class="white--text"
                                  >{{ network.networkStatus }}</v-chip
                                >
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-left>
                            <v-flex xs8>
                              <h2 class="subheading grey--text font-weight-bold">Available FNO Packages:</h2>
                            </v-flex>
                            <v-flex xs4>
                              <h3 class="grey--text font-weight-light">{{ network.availablePackages.length }}</h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-left>
                            <v-flex xs8>
                              <h2 class="subheading grey--text font-weight-bold">
                                Unused FNO Packages:
                                <v-icon color="orange" v-if="network.unusedPackages.length > 0">warning</v-icon>
                              </h2>
                            </v-flex>
                            <v-flex xs4>
                              <h3 class="grey--text font-weight-light">{{ network.unusedPackages.length }}</h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-left>
                            <v-flex xs8>
                              <h2 class="subheading grey--text font-weight-bold">Current Number of Live Packages:</h2>
                            </v-flex>
                            <v-flex xs4>
                              <h3 class="grey--text font-weight-light">{{ network.currentPackages.length }}</h3>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-dialog persistent v-model="addNewNetworkPackages" max-width="900px">
          <v-card>
            <v-toolbar flat color="primary">
              <h3 class="headline white--text">Link Package Templates</h3>
            </v-toolbar>
            <v-card-text>
              <!-- <h2  v-if="!filteredPackages" class='grey--text'>Please create package templates</h2> -->
              <v-data-table
                v-if="filteredPackages && filteredPackages.length > 0"
                :headers="packagesIspTemplatesHeaders"
                class="elevation-1"
                :items="filteredPackages"
                :rows-per-page-items="[25, 50, 100, 250]"
                v-model="filteredPackagesTable"
                item-key="id"
                align-center
                select-all
              >
                <template v-slot:items="props">
                  <td>
                    <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
                  </td>
                  <td class="text-xs-center">{{ props.item.speedProfile.name }}</td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.recurringPrice | currency }}</td>
                  <td class="text-xs-center">{{ props.item.onceOffPrice | currency }}</td>
                  <td class="text-xs-center" v-if="props.item.isFup">
                    <v-icon color="green">done</v-icon>
                  </td>
                  <td class="text-xs-center" v-else>
                    <v-icon color="red">not_interested</v-icon>
                  </td>
                  <td class="text-xs-center" v-if="props.item.isShaped">
                    <v-icon color="green">done</v-icon>
                  </td>
                  <td class="text-xs-center" v-else>
                    <v-icon color="red">not_interested</v-icon>
                  </td>
                  <td class="text-xs-center" v-if="props.item.isCapped">
                    <v-icon color="green">done</v-icon>
                  </td>
                  <td class="text-xs-center" v-else>
                    <v-icon color="red">not_interested</v-icon>
                  </td>

                  <td class="text-xs-center">{{ props.item.term }}</td>
                </template>
                <template v-slot:pageText="props"
                  >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template
                >
              </v-data-table>
              <h3 class="grey--text" v-else>You don't have any package templates that match the available speeds.</h3>
            </v-card-text>
            <v-card-actions>
              <v-layout justify-center>
                <!-- <v-btn v-if="filteredPackagesTable.length>0" round color="primary" @click="addNewNetworkPackages=false;">NEXT</v-btn> -->
                <v-btn
                  v-if="filteredPackages && filteredPackages.length > 0"
                  round
                  color="primary"
                  @click="addNewNetworkPackages = false"
                  >Cancel</v-btn
                >
                <v-btn
                  round
                  color="primary"
                  v-if="filteredPackages && filteredPackages.length > 0"
                  @click="savePackages()"
                  >Save</v-btn
                >
                <v-btn
                  v-if="!filteredPackages || filteredPackages.length == 0"
                  round
                  color="primary"
                  @click="addNewNetworkPackages = false"
                  >Okay</v-btn
                >
                <!-- <v-btn v-else disabled round color="primary">NEXT</v-btn> -->
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Add Package Modal -->
        <v-dialog persistent v-model="addPackageModal" width="750px">
          <v-card flat color="white" v-if="item && item.packageCode">
            <v-toolbar flat class="primary">
              <h1 class="headline white--text">{{ item.modalType }} Package: {{ item.packageCode }}</h1>
              <v-spacer></v-spacer>
              <v-btn flat color="white" class="white--text" @click="(addPackageModal = false), (item = {})">X</v-btn>
            </v-toolbar>
            <v-card-text mx-1 :key="modalKey">
              <v-layout justify-center align-center wrap>
                <v-flex xs6>
                  <v-checkbox
                    v-model="attachPackageToTemplate"
                    label="Attach Package to Template"
                    persistent-hint
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6 v-if="attachPackageToTemplate && availablePackageTemplates.length > 0">
                  <v-autocomplete
                    clearable
                    flat
                    color="primary"
                    label="*Select a Package Template"
                    :items="availablePackageTemplates"
                    item-text="name"
                    item-value="id"
                    return-object
                    v-model="item.packagesIspTemplate"
                    @change="updateKey()"
                  ></v-autocomplete>
                </v-flex>
                <v-flex v-else-if="attachPackageToTemplate && availablePackageTemplates.length === 0">
                  <span class="subheading"
                    >You have no available Package Templates that match the chosen FNO Package.</span
                  >
                </v-flex>
                <v-flex
                  v-if="
                    datatillProducts &&
                      datatillProducts.length > 0 &&
                      !attachPackageToTemplate &&
                      item.modalType == 'Add'
                  "
                  xs6
                >
                  <v-autocomplete
                    clearable
                    flat
                    color="primary"
                    :items="datatillProducts"
                    item-text="product_title"
                    item-value="product_id"
                    return-object
                    @change="populateDatatillDetails(datatillProduct)"
                    v-model="datatillProduct"
                    label="Linked DataTill Product"
                  ></v-autocomplete>
                </v-flex>
                <v-flex v-else-if="datatillProducts && datatillProducts.length > 0" xs6>
                  <v-autocomplete
                    clearable
                    flat
                    color="primary"
                    :items="datatillProducts"
                    item-text="product_title"
                    item-value="product_id"
                    return-object
                    @change="populateDatatillDetails(datatillProduct)"
                    v-model="datatillProduct"
                    label="Linked DataTill Product"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-layout justify-center align-center wrap>
                    <v-flex xs6 v-if="$store.state.currentOrg.org.accountingSystem">
                      <v-select
                        @change="item.accountCode = null"
                        :items="['Item', 'Account']"
                        label="Billing Type"
                        v-model="item.accountType"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 v-if="accountingAccounts.length > 0">
                      <v-autocomplete
                        v-if="
                          item.accountType == 'Account' && $store.state.currentOrg.org.accountingSystem == 'SageOne'
                        "
                        :items="accountingAccounts"
                        item-text="name"
                        item-value="id"
                        label="Associated Account"
                        v-model="item.accountCode"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-else-if="
                          item.accountType == 'Account' && $store.state.currentOrg.org.accountingSystem == 'Xero'
                        "
                        :items="accountingAccounts"
                        item-text="name"
                        item-value="id"
                        label="Associated Account"
                        v-model="item.accountCode"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 v-if="accountingItems.length > 0">
                      <v-autocomplete
                        v-if="item.accountType == 'Item' && $store.state.currentOrg.org.accountingSystem == 'SageOne'"
                        :items="accountingItems"
                        item-text="name"
                        item-value="id"
                        label="Associated Item"
                        v-model="item.accountCode"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex
                  xs12
                  mx-1
                  v-if="
                    !attachPackageToTemplate ||
                      (attachPackageToTemplate && item.packagesIspTemplate && item.packagesIspTemplate.id)
                  "
                >
                  <h3 class="grey--text">Package Details</h3>
                </v-flex>
                <v-layout
                  :key="modalKey"
                  v-if="attachPackageToTemplate && item.packagesIspTemplate && item.packagesIspTemplate.id"
                  justify-center
                  align-center
                  wrap
                >
                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Package Name:</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{ item.packagesIspTemplate.name }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Description:</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{
                          item.packagesIspTemplate.description
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Term:</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{ item.packagesIspTemplate.term }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Capped:</h4></v-flex>
                      <v-flex xs5 mx-1>
                        <v-icon v-if="item.packagesIspTemplate.isCapped" color="light-green"
                          >check_circle_outline</v-icon
                        >
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1 v-if="item.packagesIspTemplate.isCapped">
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Capped Amount(Gb):</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{
                          item.packagesIspTemplate.cappedAmountGb
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Shaped:</h4></v-flex>
                      <v-flex xs5 mx-1>
                        <v-icon v-if="item.packagesIspTemplate.isShaped" color="light-green"
                          >check_circle_outline</v-icon
                        >
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Fair Usage Policy:</h4></v-flex>
                      <v-flex xs5 mx-1>
                        <v-icon v-if="item.packagesIspTemplate.isFup" color="light-green">check_circle_outline</v-icon>
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Promotional Package:</h4></v-flex>
                      <v-flex xs5 mx-1>
                        <v-icon v-if="item.packagesIspTemplate.isPromo" color="light-green"
                          >check_circle_outline</v-icon
                        >
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1 v-if="item.packagesIspTemplate.isPromo">
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Promotional Description:</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{
                          item.packagesIspTemplate.promoDescription
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Specific T's & C's:</h4></v-flex>
                      <v-flex xs5 mx-1>
                        <v-icon v-if="item.packagesIspTemplate.hasSpecificTerms" color="light-green"
                          >check_circle_outline</v-icon
                        >
                        <v-icon v-else color="red">cancel</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1 v-if="item.packagesIspTemplate.hasSpecificTerms">
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Specific Terms:</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{
                          item.packagesIspTemplate.specificTerms
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Once Off Sales Amount:</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{
                          item.packagesIspTemplate.onceOffPrice | currency
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>
                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Recurring Monthly Sales Amount:</h4></v-flex>
                      <v-flex xs5 mx-1
                        ><span class="grey--text font-weight-light">{{
                          item.packagesIspTemplate.recurringPrice | currency
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Once Off Gross Profit/Loss:</h4></v-flex>
                      <v-flex xs5 mx-1>
                        <!-- <v-flex xs5 mx-1><span class="grey--text ">{{grossProfit(item.packagesIspTemplate.onceOffPrice,item.setupFee)|currency}}</span></v-flex> -->
                        <span
                          class="green--text"
                          v-if="grossProfit(item.packagesIspTemplate.onceOffPrice, item.setupFee) > 0"
                          >{{ grossProfit(item.packagesIspTemplate.onceOffPrice, item.setupFee) | currency }}</span
                        >
                        <span class="red--text" v-else>{{
                          grossProfit(item.packagesIspTemplate.onceOffPrice, item.setupFee) | currency
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>
                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap class="text-xs-left">
                      <v-flex xs5 mx-1><h4 class="grey--text">Recurring Gross Profit:</h4></v-flex>
                      <v-flex xs5 mx-1>
                        <span
                          class="green--text"
                          v-if="grossProfit(item.packagesIspTemplate.recurringPrice, item.packageBasePrice) > 0"
                          >{{
                            grossProfit(item.packagesIspTemplate.recurringPrice, item.packageBasePrice) | currency
                          }}</span
                        >
                        <span class="red--text" v-else>{{
                          grossProfit(item.packagesIspTemplate.recurringPrice, item.packageBasePrice) | currency
                        }}</span></v-flex
                      >
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout v-if="!attachPackageToTemplate" justify-center align-center wrap :key="modalKey">
                  <v-flex xs5 mx-1>
                    <v-text-field
                      @change="modalKey++"
                      label="*Package Name"
                      v-model="item.newPackage.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 mx-1>
                    <v-select
                      @change="modalKey++"
                      label="*Term"
                      :items="packageTerms"
                      v-model="item.newPackage.term"
                    ></v-select>
                  </v-flex>
                  <v-flex xs10 mx-1>
                    <v-textarea
                      @change="modalKey++"
                      label="*Description"
                      v-model="item.newPackage.description"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-switch label="Capped" v-model="isCapped"></v-switch>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-text-field
                      v-if="isCapped"
                      label="Capped Amount (Gb)"
                      v-model="item.newPackage.cappedAmountGb"
                      type="number"
                      step="1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-switch label="Shaped" v-model="isShaped"></v-switch>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-switch label="Fair Usage Policy" v-model="isFup"></v-switch>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-switch label="Promotion" v-model="isPromo"></v-switch>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-textarea
                      v-if="isPromo"
                      label="Promotion Description"
                      v-model="item.newPackage.promotionDescription"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-switch label="Are there specific T's & C's?" v-model="hasSpecificTerms"></v-switch>
                  </v-flex>
                  <v-flex xs4 mx-1 v-if="hasSpecificTerms">
                    <v-textarea
                      @change="modalKey++"
                      label="*Specific T's & C's"
                      v-model="item.newPackage.specificTerms"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout justify-center align-center wrap>
                      <v-flex xs6 mx-1>
                        <v-text-field
                          @change="modalKey++"
                          label="*Recurring Monthly Price incl. VAT"
                          type="number"
                          v-model="item.newPackage.recurringPriceVatInc"
                        ></v-text-field>
                        <h4 class="grey--text">
                          FNO Recurring Monthly Fee:
                          <span class="font-weight-light red--text">{{ item.packageBasePrice | currency }}</span>
                        </h4>
                      </v-flex>
                      <v-flex xs6 mx-1>
                        <v-text-field
                          @change="modalKey++"
                          label="*Once-Off Fee incl. VAT"
                          type="number"
                          v-model="item.newPackage.onceOffPriceVatInc"
                        ></v-text-field>
                        <h4 class="grey--text">
                          FNO Setup Fee: <span class="font-weight-light red--text">{{ item.setupFee | currency }}</span>
                        </h4>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-card-actions mx-3 :key="modalKey">
                  <v-layout justify-center>
                    <v-btn
                      :key="modalKey"
                      v-if="
                        item.modalType == 'Add' &&
                          attachPackageToTemplate &&
                          item.packagesIspTemplate &&
                          item.packagesIspTemplate.id
                      "
                      color="primary"
                      class="white--text"
                      round
                      @click="createPackageFromTemplate()"
                      >Create Package</v-btn
                    >
                    <v-btn
                      :key="modalKey"
                      round
                      color="primary"
                      class="white--text"
                      v-else-if="
                        item.modalType == 'Add' &&
                          !attachPackageToTemplate &&
                          item.newPackage.name &&
                          item.newPackage.description &&
                          ((isCapped && item.newPackage.cappedAmountGb > 0) || !isCapped) &&
                          ((hasSpecificTerms && item.newPackage.specificTerms) || !hasSpecificTerms) &&
                          item.newPackage.recurringPriceVatInc &&
                          item.newPackage.onceOffPriceVatInc
                      "
                      @click="saveNewPackage()"
                      >Create Package</v-btn
                    >
                    <v-btn :key="modalKey" round disabled v-else-if="item.modalType == 'Add'">Create Package</v-btn>

                    <v-btn
                      :key="modalKey"
                      round
                      class="white--text"
                      color="primary"
                      v-if="
                        item.modalType == 'Edit' &&
                          attachPackageToTemplate &&
                          item.packagesIspTemplate &&
                          item.packagesIspTemplate.id
                      "
                      @click="savePackageFromTemplate()"
                      >Save</v-btn
                    >
                    <v-btn
                      :key="modalKey"
                      round
                      color="primary"
                      class="white--text"
                      v-else-if="
                        item.modalType == 'Edit' &&
                          !attachPackageToTemplate &&
                          item.newPackage.name &&
                          item.newPackage.description &&
                          ((isCapped && item.newPackage.cappedAmountGb > 0) || !isCapped) &&
                          ((hasSpecificTerms && item.newPackage.specificTerms) || !hasSpecificTerms) &&
                          item.newPackage.recurringPriceVatInc &&
                          item.newPackage.onceOffPriceVatInc
                      "
                      @click="savePackage()"
                      >Save</v-btn
                    >
                    <v-btn :key="modalKey" v-else-if="item.modalType == 'Edit'" round disabled>Save</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <div v-else style="height: 90vh">
      <v-layout justify-center align-center>
        <v-progress-circular size="50" indeterminate color="primary"></v-progress-circular>
      </v-layout>
    </div>
  </div>
</template>
<script>
import Api from "../services/Api";
import CoverageMap from "./CoverageMap.vue";
export default {
  components: {
    coveragemap: CoverageMap,
  },
  data() {
    return {
      key: 0,
      pagination: {
        sortBy: null,
        descending: false,
        page: 1,
        itemsPerPage: 5,
      },
      globalIspPackagesSearch: "",
      globalIspPackagesPagination: { descending: false, sortBy: "packagesFno.speedProfile.downloadMbps" },
      accountingAccounts: [],
      accountingItems: [],
      datatillProduct: null,
      datatillProducts: [],
      activeTabName: "coverageMap",
      activePackagesIsps: [],
      activeNetworks: [],
      addPackageModal: false,
      availablePackageTemplates: [],
      addNewNetworkPackages: false,
      attachPackageToTemplate: false,
      currentLocationNetworkId: null,
      globalFNOPackages: [],
      globalIspPackages: [],
      filteredPackages: [],
      modalKey: 0,
      newNetworks: [],
      networks: [],
      directNetworks: [],
      virtualNetworks: [],
      geoData: null,
      initialActivePackagesIsps: [],
      locationNetworks: [],
      packageTerms: ["month-to-month", "6 month", "12 month", "24 month"],
      isCapped: false,
      isShaped: false,
      isPromo: false,
      isFup: false,
      hasSpecificTerms: false,
      networkOperator: null,
      networkSearch: "",
      packageTemplates: [],
      loading: true,
      snackbard: false,
      virtualPackages: [],
      tabs: [
        { name: "coverageMap", displayName: "Coverage Map" },
        { name: "networkList", displayName: "Network List" },
        { name: "packages", displayName: "Packages" },
      ],
      networkHeaders: [
        {
          text: "Network Operator",
          align: "center",
          value: "organisation.name",
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Region",
          align: "center",
          value: "region.name",
        },
        {
          text: "Status",
          align: "center",
          value: "networkStatus",
        },

        {
          text: "Units Passed",
          align: "center",
          value: "numberOfUnits",
        },
      ],
      packagesIspTemplatesHeaders: [
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name",
        },
        {
          text: "Template Name",
          align: "center",
          value: "name",
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice",
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice",
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup",
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped",
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped",
        },
        {
          text: "Term",
          align: "center",
          value: "term",
        },
      ],
      networkPackageHeaders: [
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Network Status",
          align: "center",
          value: "networkStatus",
        },
        {
          text: "Available FNO Packages",
          align: "center",
          sortable: false,
        },
        {
          text: "Unused FNO Packages",
          align: "center",
          sortable: false,
        },
        {
          text: "No. of Live Packages",
          align: "center",
          sortable: false,
        },
      ],
      globalFnoPackageHeaders: [
        {
          text: "Type",
          align: "center",
          value: "type",
        },
        {
          text: "Name",
          align: "center",
          value: "packageCode",
        },
        {
          text: "Category",
          align: "center",
          value: "packagesFnoCat.name",
        },
        {
          text: "Price excl. VAT",
          align: "center",
          value: "packageBasePrice",
        },
        {
          text: "Speed",
          align: "center",
          value: "speedProfile.downloadMbps",
        },
      ],
      globalIspPackageHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "packagesFno.type",
          sortable: true,
        },
        {
          text: "Name",
          align: "center",
          value: "name",
          sortable: true,
        },
        {
          text: "Once Off Fee incl. VAT",
          align: "center",
          value: "onceOffPriceVatInc",
          sortable: true,
        },
        {
          text: "Monthly Price incl. VAT",
          align: "center",
          value: "recurringPriceVatInc",
          sortable: true,
        },
        {
          text: "Speed",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps",
          sortable: true,
        },
        {
          text: "Status",
          align: "center",
          value: "isActive",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    attachPackageToTemplate(value) {
      this.modalKey += 1;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    copyReference(){
            let text = this.networkOperator.applicationURL+'?isp='+this.$store.state.currentOrg.org.reference
            navigator.clipboard.writeText(text)
            this.snackbar = true
        },
    populateDatatillDetails(product) {
      if (product) {
        if (this.attachPackageToTemplate) {
          this.item.packagesIspTemplate.datatillProductId = product.product_id;
          this.item.packagesIspTemplate.cappedAmountGb = product.cap_size;
          this.item.packagesIspTemplate.recurringPriceVatInc = product.monthly_cost;
          this.item.packagesIspTemplate.name = product.product_title;
          if (product.cap_size === 0) {
            this.item.packagesIspTemplate.isCapped = false;
            this.isCapped = false;
          } else {
            this.item.packagesIspTemplate.isCapped = true;
            this.isCapped = true;
          }
        } else {
          this.item.newPackage.datatillProductId = product.product_id;
          this.item.newPackage.cappedAmountGb = product.cap_size;
          this.item.newPackage.recurringPriceVatInc = product.monthly_cost;
          this.item.newPackage.name = product.product_title;
          if (product.cap_size === 0) {
            this.isCapped = false;
            this.item.newPackage.isCapped = false;
          } else {
            this.isCapped = true;
            this.item.newPackage.isCapped = true;
          }
        }
      } else {
        if (this.attachPackageToTemplate) {
          this.item.packagesIspTemplate.datatillProductId = null;
          this.item.packagesIspTemplate.cappedAmountGb = 0;
          this.item.packagesIspTemplate.recurringPriceVatInc = 0;
          this.item.packagesIspTemplate.name = "";
          this.item.packagesIspTemplate.isCapped = true;
          this.isCapped = true;
        } else {
          this.item.newPackage.datatillProductId = null;
          this.item.newPackage.cappedAmountGb = 0;
          this.item.newPackage.recurringPriceVatInc = 0;
          this.item.newPackage.name = "";
          this.item.newPackage.isCapped = true;
          this.isCapped = true;
        }
      }
    },
    async initialize() {
      await this.getNetworkOperatorDetails();
      await this.getNetworkOperatorsNetworks();
      await this.getPackageTemplates();
      // this.fetchDatatillIntegration()
      this.fetchGlobalPackages();
      if (this.$store.state.currentOrg.org.accountingSystem == "SageOne") {
        this.fetchSageAccounts();
        this.fetchSageItems();
      } else if (this.$store.state.currentOrg.org.accountingSystem == "Xero") {
        this.fetchXeroAccounts();
        this.fetchXeroItems();
      }
      this.loading = false;
    },
    async fetchXeroAccounts() {
      await Api()
        .get("/xero/accounts")
        .then((res) => {
          let result = res.data.body.accounts;
          this.accountingAccounts = result.map((x) => ({ id: x.accountID, name: x.name }));
        });
    },
    async fetchXeroItems() {
      await Api()
        .get("/xero/items")
        .then((res) => {
          let result = res.data.body.items;

          this.accountingItems = result.map((x) => ({ id: x.itemID, name: x.name }));
        });
    },
    async fetchSageAccounts() {
      await Api()
        .get("/sageOne/accounts")
        .then((res) => {
          let result = res.data.Results.filter((x) => x.Category.ID == 1);
          this.accountingAccounts = result.map((x) => ({ id: x.ID.toString(), name: x.Name }));
        });
    },
    async fetchSageItems() {
      await Api()
        .get("/sageOne/items")
        .then((res) => {
          this.accountingItems = res.data.Results.map((x) => ({ id: x.ID.toString(), name: x.Code }));
        });
    },
    async fetchDatatillIntegration() {
      await Api()
        .get("/datatill/dataProducts/" + this.$store.state.currentOrg.org.id)
        .then((response) => {
          this.datatillProducts = response.data.data_product_list;
        });
    },
    async getPackageTemplates() {
      await Api()
        .get("/customer/packagesIspTemplate")
        .then((response) => {
          this.packageTemplates = response.data;
        });
    },
    updatePackageStatus(item) {
      Api()
        .put("/customer/packagesIsps/" + item.id, { isActive: !item.isActive })
        .then((response) => {
          let find = this.globalIspPackages.find((x) => x.id === item.id);
          let index = this.globalIspPackages.indexOf(find);
          this.globalIspPackages[index].isActive = !item.isActive;
          this.key += 1;
        });
    },
    savePackage() {
      this.item.newPackage.isCapped = this.isCapped;
      this.item.newPackage.isShaped = this.isShaped;
      this.item.newPackage.isPromotion = this.isPromo;
      this.item.newPackage.isFup = this.isFup;
      this.item.newPackage.hasSpecificTerms = this.hasSpecificTerms;
      delete this.item.newPackage.packagesFno;
      this.item.newPackage.accountCode = this.item.accountCode;
      this.item.newPackage.accountType = this.item.accountType;

      let item = this.item.newPackage;
      let find = this.globalIspPackages.find(x=>x.id == item.id)
      if(find){
 let index = this.globalIspPackages.indexOf(find)
        this.globalIspPackages[index] = item;
      }
     
      Api()
        .put("/customer/packagesIsps/" + item.id, item)
        .then((response) => {
          this.item = {};
          this.addPackageModal = false;
          this.fetchGlobalIspPackages();
        });
        
    },
    updateKey() {
      this.modalKey += 1;
    },
    savePackageFromTemplate() {
      let obj = {
        accountCode: this.item.accountCode,
        accountType: this.item.accountType,
        name: this.item.packagesIspTemplate.name,
        description: this.item.packagesIspTemplate.description,
        promoDescription: this.item.packagesIspTemplate.promoDescription,
        onceOffPriceVatInc: this.item.packagesIspTemplate.onceOffPrice,
        recurringPriceVatInc: this.item.packagesIspTemplate.recurringPrice,
        isPromotion: this.item.packagesIspTemplate.isPromo,
        promotionDescription: this.item.packagesIspTemplate.promoDescription,
        term: this.item.packagesIspTemplate.term,
        isCapped: this.item.packagesIspTemplate.isCapped,
        isShaped: this.item.packagesIspTemplate.isShaped,
        cappedAmountGb: this.item.packagesIspTemplate.cappedAmountGb,
        isFup: this.item.packagesIspTemplate.isFup,
        startDate: this.item.startDate,
        endDate: this.item.endDate,
        packagesFnoId: this.item.id,
        isVerified: this.item.isVerified,
        createdById: this.item.createdById,
        lastModifiedById: this.$store.state.user.id,
        verifiedById: this.item.verifiedById,
        packagesIspTemplateId: this.item.packagesIspTemplate.id,
        // isActive: this.item.isActive,
        hasSpecificTerms: this.item.packagesIspTemplate.hasSpecificTerms,
        specificTerms: this.item.packagesIspTemplate.specificTerms,
        datatillProductId: this.item.packagesIspTemplate.datatillProductId,
      };
      Api()
        .put("/customer/packagesIsps/" + this.item.newPackage.id, obj)
        .then((response) => {
          this.item = {};
          this.addPackageModal = false;
          this.fetchGlobalIspPackages();
        });
    },
    getNetworkOperatorDetails() {
      Api()
        .get("/organisation/basic/" + this.$route.params.networkOperatorId)
        .then((response) => {
          this.networkOperator = response.data;
        });
    },
    async savePackages() {
      let post = [];
      Api()
        .get("/locationNetwork/basic/" + this.currentLocationNetworkId)
        .then(async (response) => {
          await this.filteredPackagesTable.map(async (x) => {
            let ispLocationNetworkId = await this.selectedLocationNetwork.availablePackages.filter((el) => {
              return el.locationNetworkId === this.currentLocationNetworkId && el.packagesFno.id === x.packagesFnoId;
            })[0].ispLocationNetworkId;
            post.push({
              name: x.name,
              description: x.description,
              term: x.term,
              isVerified: true,
              verifiedById: this.$store.state.user.id,
              createdById: this.$store.state.user.id,
              lastModifiedById: this.$store.state.user.id,
              customerOrganisationId: x.customerOrganisationId,
              speedProfileId: x.speedProfileId,
              recurringPriceVatInc: x.recurringPrice,
              onceOffPriceVatInc: x.onceOffPrice,
              customerId: x.customerId,
              isCapped: x.isCapped,
              isFup: x.isFup,
              isPromotion: x.isPromo,
              isShaped: x.isShaped,
              cappedAmountGb: x.cappedAmountGb,
              startDate: new Date(),
              packagesFnoId: x.packagesFnoId,
              layer3Contention: x.layer3Contention,
              promotionDescription: x.promoDescription,
              organisationId: x.organisationId,
              hasSpecificTerms: x.hasSpecificTerms,
              specificTerms: x.specificTerms,
              locationNetworkId: this.currentLocationNetworkId,
              ispLocationNetworkId: ispLocationNetworkId,
              isDeleted: false,
              isActive: true,
            });
          });
          confirm("Are you sure you want to link " + post.length + " packages to " + response.data.name) &&
            Api()
              .post("/customer/bulkPackagesIsps", {
                batch: post,
              })
              .then((response) => {
                this.$emit("packagesIspsSaved");
                this.addNewNetworkPackages = false;
              });
        });
    },
    async packageSummaryredirect(networkId) {
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/packageSummary/:locationNetworkId";
      });
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/packageSummary/" + networkId });
    },
    async globalPackageSummaryredirect(packagesIspId) {
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/globalPackageSummary/:packagesIspId";
      });
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/globalPackageSummary/" + packagesIspId });
    },
    async fetchAllPackagesIsps() {
      this.isloading = true;
      let locationNetworkId = [];
      this.locationNetworks = [];
      this.packageOverview = [];
      let packages = [];
      await Api()
        .get("/customer/packagesIsps/basic/active")
        .then((response) => {
          this.activePackagesIsps = response.data;
          this.initialActivePackagesIsps = response.data;
          this.isLoading = false;
        });
      await Api()
        .get("/customer/ispLocationNetwork")
        .then(async (response) => {
          for (let i = 0; i < response.data.length; i++) {
            if (!locationNetworkId.includes(response.data[i].locationNetworkId)) {
              await locationNetworkId.push(response.data[i].locationNetworkId);
              await this.locationNetworks.push(response.data[i].locationNetwork);
            }
            await packages.push({
              locationNetworkId: response.data[i].locationNetworkId,
              packagesFno: response.data[i].packagesFno,
              ispLocationNetworkId: response.data[i].id,
            });
          }
        });
      for (let b = 0; b < this.locationNetworks.length; b++) {
        let id = this.locationNetworks[b].id;
        let availablePackages = await packages.filter(function(el) {
          return el.locationNetworkId === id && el.packagesFno.isActive === true && el.packagesFno.isDeleted === false;
        });
        availablePackages = availablePackages.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) => t.packagesFno.id === item.packagesFno.id && t.locationNetworkId === item.locationNetworkId
            )
        );
        let currentPackages = await this.initialActivePackagesIsps.filter(function(el) {
          return el.locationNetworkId === id && el.isActive === true && el.isVerified === true;
        });
        let currentFnoPackages = [];
        for (let a = 0; a < currentPackages.length; a++) {
          await currentFnoPackages.push(currentPackages[a].packagesFnoId);
        }
        let unusedPackages = [];
        this.locationNetworks[b].availablePackages = availablePackages;
        for (let x = 0; x < availablePackages.length; x++) {
          if (!currentFnoPackages.includes(availablePackages[x].packagesFno.id)) {
            if (!unusedPackages.includes(availablePackages[x].packagesFno)) {
              await unusedPackages.push(availablePackages[x].packagesFno);
            }
          }
        }
        this.locationNetworks[b].currentPackages = currentPackages;
        this.locationNetworks[b].unusedPackages = unusedPackages;
      }
      this.locationNetworks.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
    },
    async fetchAllNetworks() {
      this.isLoading = true;
      this.newNetworks = [];
      this.activeNetworks = [];
      this.activeNetworks = this.locationNetworks.filter((x) => x.currentPackages && x.currentPackages.length > 0);
      this.newNetworks = this.locationNetworks.filter((x) => !x.currentPackages || x.currentPackages.length == 0);

      this.key++;
    },
    async addPackageTemplates(network) {
      let item = network.unusedPackages;
      this.currentLocationNetworkId = network.id;
      this.selectedLocationNetwork = await this.locationNetworks.find((x) => x.id == this.currentLocationNetworkId);
      let speedArray = [];
      this.filteredPackages = [];
      await item.filter(function(x) {
        if (!speedArray.some((item) => item.speedProfileId === x.speedProfileId)) {
          speedArray.push({
            speedProfileId: x.speedProfileId,
            packagesFnoId: x.id,
          });
        }
      });
      Api()
        .get("/packagesIspTemplate/byCustomer")
        .then(async (response) => {
          await response.data.map(async (x) => {
            let fnoPackage = await speedArray.find((y) => y.speedProfileId === x.speedProfileId);
            if (fnoPackage) {
              this.filteredPackages.push({
                cappedAmountGb: x.cappedAmountGb,
                customerId: x.customerId,
                customerOrganisationId: x.customerOrganisationId,
                description: x.description,
                hasSpecificTerms: x.hasSpecificTerms,
                id: x.id,
                isActive: x.isActive,
                isCapped: x.isCapped,
                isDeleted: x.isDeleted,
                isFup: x.isFup,
                isPromo: x.isPromo,
                isShaped: x.isShaped,
                layer3Contention: x.layer3Contention,
                name: x.name,
                onceOffPrice: x.onceOffPrice,
                organisationId: x.organisationId,
                packageIspCatId: x.packageIspCatId,
                promoDescription: x.promoDescription,
                recurringPrice: x.recurringPrice,
                specificTerms: x.specificTerms,
                speedProfile: x.speedProfile,
                speedProfileId: x.speedProfileId,
                term: x.term,
                packagesFnoId: fnoPackage.packagesFnoId,
              });
            }
          });
          this.addNewNetworkPackages = true;
        });
    },
    getNetworkOperatorsNetworks() {
      Api()
        .get("/networkOperators/networks/" + this.$route.params.networkOperatorId)
        .then(async (response) => {
          if (response.data.directNetworks.length > 0) {
            response.data.directNetworks.map((x) => {
              this.networks.push({
                id: x.locationNetwork.id,
                name: x.locationNetwork.name,
                networkStatus: x.locationNetwork.networkStatus,
                backhaulType: x.locationNetwork.backhaulType,
                region: x.locationNetwork.region,
                numberOfUnits: x.locationNetwork.numberOfUnits,
                organisation: x.organisation,
              });
            });
          }
          if (response.data.globalNetworks.length > 0) {
            response.data.globalNetworks.map((x) => {
              this.networks.push({
                id: x.id,
                name: x.name,
                networkStatus: x.networkStatus,
                backhaulType: x.backhaulType,
                region: x.region,
                numberOfUnits: x.numberOfUnits,
                organisation: x.organisation,
              });
            });
          }
          if (response.data.virtualNetworks.length > 0) {
            response.data.virtualNetworks.map((x) => {
              this.networks.push({
                id: x.id,
                name: x.name,
                networkStatus: x.networkStatus,
                backhaulType: x.backhaulType,
                region: x.region,
                numberOfUnits: x.numberOfUnits,
                organisation: x.organisation,
              });
            });
          }
          await this.getNetworkPolygons();

          await this.fetchAllPackagesIsps();
          await this.fetchAllNetworks();
        });
    },
    async addGlobalISPPackage(item) {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.item = item;
        this.item.modalType = "Add";
        this.item.newPackage = {
          recurringPriceInclVat: 0,
          onceOffPriceInclVat: 0,
          datatillProductId: null,
        };
        this.item.attachPackageToTemplate = true;
        this.isCapped = true;
        this.isShaped = true;
        this.isPromo = true;
        this.isFup = true;
        this.hasSpecificTerms = false;
        this.datatillProduct = null;
        // this.item = await Object.assign({}, item);
        this.availablePackageTemplates = await this.packageTemplates.filter(
          (x) => x.speedProfileId === item.speedProfileId
        );
        if (this.item.endDate !== null) {
          this.item.endDate = new Date(this.item.endDate).toISOString().substr(0, 10);
        }
        if (this.item.startDate !== null) {
          this.item.startDate = new Date(this.item.startDate).toISOString().substr(0, 10);
        }
        this.addPackageModal = true;
      }
    },
    async deleteGlobalISPPackage(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to delete this package?") &&
          Api()
            .put("/customer/packagesIsps/" + item.id, { isDeleted: true, isActive: false })
            .then((response) => {
              // let find = this.globalIspPackages.find(x=>x.id===item.id)
              let index = this.globalIspPackages.indexOf(item);
              this.globalIspPackages.splice(index, 1);
              this.key += 1;
            });
      }
    },
    async editGlobalISPPackage(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.item = item.packagesFno;
        this.item.modalType = "Edit";
        this.item.accountCode = item.accountCode;
        this.item.newPackage = item;
        this.attachPackageToTemplate = item.packagesIspTemplateId ? true : false;
        this.isCapped = item.isCapped;
        this.isShaped = item.isShaped;
        this.isPromo = item.isPromotion;
        this.isFup = item.isFup;
        this.hasSpecificTerms = item.hasSpecificTerms;
        this.item.packagesIspTemplate = item.packagesIspTemplate;
        this.availablePackageTemplates = await this.packageTemplates.filter(
          (x) => x.speedProfileId === item.packagesFno.speedProfileId
        );
        if (this.item.endDate !== null) {
          this.item.endDate = new Date(this.item.endDate).toISOString().substr(0, 10);
        }
        if (this.item.startDate !== null) {
          this.item.startDate = new Date(this.item.startDate).toISOString().substr(0, 10);
        }
        this.addPackageModal = true;
      }
    },
    grossProfit(IspPrice, FnoPrice) {
      return parseFloat(IspPrice) - parseFloat(FnoPrice) * (1 + $VAT);
    },
    fetchGlobalPackages() {
      Api()
        .get("/packagesFnos/basic/global/customer/" + this.$route.params.networkOperatorId)
        .then(async (response) => {
          this.globalFNOPackages = response.data;
          this.fetchGlobalIspPackages();
        });
    },
    fetchGlobalIspPackages() {
      let array = this.globalFNOPackages.map((x) => x.id);
      Api()
        .post("/packagesIsp/globalPackages", array)
        .then((response) => {
          this.globalIspPackages = response.data;
          this.key += 1;
        });
    },
    async getNetworkPolygons() {
      await Api()
        .post("/locationNetworkPolygon/customer/byNetworks", {
          networkIds: [...new Set(this.networks.map((x) => x.id))],
        })
        .then((response) => {
          let geoObj = {
            type: "FeatureCollection",
            name: "Network Polygons",
            crs: {
              type: "name",
              properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
            },
            features: [],
          };
          let objects = response.data;
          for (let x = 0; x < objects.length; x++) {
            let obj = {
              type: "Feature",
              properties: {
                name: objects[x].locationNetwork ? objects[x].locationNetwork.name : objects[x].name,
                fno: objects[x].organisation,
                network: objects[x],
                description: null,
                units: objects[x].locationNetwork ? objects[x].locationNetwork.numberOfUnits : objects[x].numberOfUnits,
                tessellate: 1,
              },
              geometry: {
                type: "Polygon",
                coordinates: objects[x].coordinates ? JSON.parse(objects[x].coordinates) : [],
              },
            };
            if (
              obj.geometry.coordinates.length > 0 &&
              obj.geometry.coordinates[0] &&
              obj.geometry.coordinates[0][0] &&
              obj.geometry.coordinates[0][0][0]
            ) {
              if (
                obj.geometry.coordinates[0][0][0] !==
                  obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][0] ||
                obj.geometry.coordinates[0][0][1] !==
                  obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][1]
              ) {
                obj.geometry.coordinates[0].push(obj.geometry.coordinates[0][0]);
              }
              geoObj.features.push(obj);
            }
          }
          // geoObj.features = response.data.map((x) => ({
          //   type: "Feature",
          //   properties: {
          //     name: x.locationNetwork ? x.locationNetwork.name : x.name,
          //     fno: x.organisation,
          //     network: x,
          //     description: null,
          //     units: x.locationNetwork
          //       ? x.locationNetwork.numberOfUnits
          //       : x.numberOfUnits,
          //     tessellate: 1,
          //   },
          //   geometry: {
          //     type: "Polygon",
          //     coordinates:
          //       x.coordinates.length > 0 ? JSON.parse(x.coordinates) : [],
          //   },
          // }));
          this.geoData = geoObj;
          this.key++;
          // console.log(this.geoData);
          //   this.plotMap();
        });
    },
    saveNewPackage() {
      this.item.newPackage.isCapped = this.isCapped;
      this.item.newPackage.isShaped = this.isShaped;
      Api()
        .post("/customer/packagesIsps", {
          accountCode: this.item.accountCode,
          accountType: this.item.accountType,
          name: this.item.newPackage.name,
          description: this.item.newPackage.description,
          promoDescription: this.item.newPackage.promoDescription,
          onceOffPriceVatInc: this.item.newPackage.onceOffPriceVatInc,
          recurringPriceVatInc: this.item.newPackage.recurringPriceVatInc,
          isPromotion: this.item.newPackage.isPromotion,
          term: this.item.newPackage.term,
          isCapped: this.item.newPackage.isCapped,
          cappedAmountGb: this.item.newPackage.cappedAmountGb,
          isShaped: this.item.newPackage.isShaped,
          isFup: this.item.newPackage.isFup,
          fupUrl: this.item.newPackage.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: this.item.id,
          // locationNetworkId: this.$route.params.locationNetworkId,
          // ispLocationNetworkId: ispLocationNetworkId.id,
          isGlobal: true,
          supplierOrganisationId: this.$route.params.networkOperatorId,
          isRegistered: true,
          isVerified: true,
          createdById: this.$store.state.user.id,
          verifiedById: this.$store.state.user.id,
          lastModifiedById: this.$store.state.user.id,
          hasSpecificTerms: this.item.newPackage.hasSpecificTerms,
          specificTerms: this.item.newPackage.specificTerms,
          datatillProductId: this.item.newPackage.datatillProductId,
          isActive: true,
          isDeleted: false,
        })
        .then((response) => {
          this.addPackageModal = false;
          this.item = {};
          this.fetchGlobalIspPackages();
        });
    },
    createPackageFromTemplate() {
      Api()
        .post("/customer/packagesIsps", {
          accountCode: this.item.accountCode,
          name: this.item.packagesIspTemplate.name,
          description: this.item.packagesIspTemplate.description,
          onceOffPriceVatInc: this.item.packagesIspTemplate.onceOffPrice,
          recurringPriceVatInc: this.item.packagesIspTemplate.recurringPrice,
          isPromotion: this.item.packagesIspTemplate.isPromo,
          promotionDescription: this.item.packagesIspTemplate.promoDescription,
          term: this.item.packagesIspTemplate.term,
          isCapped: this.item.packagesIspTemplate.isCapped,
          isShaped: this.item.packagesIspTemplate.isShaped,
          cappedAmountGb: this.item.packagesIspTemplate.cappedAmountGb,
          isFup: this.item.packagesIspTemplate.isFup,
          fupUrl: this.item.packagesIspTemplate.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: this.item.id,
          // ispLocationNetworkId: parseInt(ispLocationNetworkId),
          // locationNetworkId: this.$route.params.locationNetworkId,
          isVerified: true,
          isRegistered: true,
          createdById: this.$store.state.user.id,
          lastModifiedById: this.$store.state.user.id,
          verifiedById: this.$store.state.user.id,
          packagesIspTemplateId: this.item.packagesIspTemplate.id,
          customerOrganisationId: this.$store.state.currentOrg.org.id,
          hasSpecificTerms: this.item.packagesIspTemplate.hasSpecificTerms,
          specificTerms: this.item.packagesIspTemplate.specificTerms,
          datatillProductId: this.item.packagesIspTemplate.datatillProductId,
          isActive: true,
        })
        .then((response) => {
          this.addPackageModal = false;
          this.item = {};
          this.fetchGlobalIspPackages();
        });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
  },
};
</script>
